module.exports = __webpack_public_path__ + "static/media/BannerCongresoMobileEN.32e12fc8.jpg";